/* eslint-disable no-param-reassign */
import { Reducer } from 'redux';
import produce from 'immer';
import { ITrackCancelState, ITrackCancelTypes } from './types';

const INITIAL_STATE: ITrackCancelState = {
  data: {
    called: '',
    description: '',
    file: [],
  },
  loading: false,
  error: null,
};

const trackCancel: Reducer<ITrackCancelState> = (
  state = INITIAL_STATE,
  action,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case ITrackCancelTypes.TRACK_CANCEL_REQUEST: {
        draft.data = {
          called: action.payload.called,
          description: action.payload.description,
          file: action.payload.file,
        };
        draft.loading = true;
        draft.error = null;
        break;
      }
      case ITrackCancelTypes.TRACK_CANCEL_SUCCESS: {
        draft.data = {
          called: '',
          description: '',
          file: [],
        };
        draft.loading = false;
        draft.error = null;
        break;
      }
      case ITrackCancelTypes.TRACK_CANCEL_FAILURE: {
        draft.data = {
          called: '',
          description: '',
          file: [],
        };
        draft.loading = false;
        draft.error = action.payload.error;
        break;
      }
      default:
        break;
    }
  });
};

export default trackCancel;
